export const ADD_LATEST_PRODUCT = 'ADD_LATEST_PRODUCT';
